import { ClientAccountInfo } from "./client-account-info";

export class ClientAccountInfoList {
  clients: ClientAccountInfo[];
}
